const modules = {
    title: String("Estacions"),
    moduleManagerTitle: String("Gestió de les meves estacions"),
    moduleNameHeader: String("Nom"),
    moduleModifyModule: String("Accions"),
    modulePlotHeader: String("Parcel·la assignada"),
    moduleEnabledHeader: String("Estat"),
    moduleTypeHeader: String("Tipus"),
    moduleInstallationDateHeader: String("Data d'instal·lació"),
    moduleParametersHeader: String("Paràmetres"),
    editButton: String("Modificar"),
    editParamsButton: String("Veure/actualitzar"),
    newModuleButton: String("Afegir estació nova"),
    moduleParamModalTitle: String("Paràmetres de l'estació {nom}"),
    updateParams: String("Actualitzar els paràmetres"),
    restoreParams: String("Restablir els paràmetres"),
    cancelButton: String("Cancel·lar"),
    module_post_flow_meter_trees: String("Arbres post-caudalímetre"),
    module_soil_moisture_max_optimal_region_percentage: String("Capacitat de camp"),
    module_soil_moisture_min_optimal_region_percentage: String("Punt de marciment permanent"),
    module_soil_moisture_shallow_depth: String("Humitat del sensor en sòl poc profund"),
    module_soil_moisture_intermediate_depth: String("Sensor d'humitat en sòl profund intermedi"),
    module_soil_moisture_greater_depth: String("Sensor d'humitat a molta profunditat"),
    module_enabled: String("Estat del sensor"),
    module_depth: String("Profunditat del sensor (cm)"),
    module_distance_to_dropper: String("Separació del goter (cm)"),
    module_max: String("Valor màxim del sensor d'humitat del sòl"),
    module_min: String("Valor mínim del sensor d'humitat del sòl"),
    module_post_flow_meter_treesInfoPopover: String("Arbres post-caudalímetre"),
    module_soil_moisture_max_optimal_region_percentageInfoPopover: String("Capacitat de camp expressat en percentatge"),
    module_soil_moisture_min_optimal_region_percentageInfoPopover: String("Punt de marciment permanent expressat en percentatge"),
    module_soil_moisture_shallow_depthInfoPopover: String("Humitat del sensor en sòl poc profund"),
    module_soil_moisture_intermediate_depthInfoPopover: String("Sensor d'humitat en sòl profund intermedi"),
    module_soil_moisture_greater_depthInfoPopover: String("Sensor d'humitat a molta profunditat"),
    module_enabledInfoPopover: String("Estat del sensor"),
    module_depthInfoPopover: String("Profunditat del sensor (cm)"),
    module_distance_to_dropperInfoPopover: String("Separació del goter (cm)"),
    module_maxInfoPopover: String("Valor màxim del sensor d'humitat del sòl"),
    module_minInfoPopover: String("Valor mínim del sensor d'humitat del sòl"),
    moduleModalTitle: String("Modificar dades de l'estació"),
    moduleName: String("Estació"),
    moduleNameInfoPopover: String("Estació"),
    moduleNamePlaceholder: String("Nom..."),
    modulePlot: String("Parcel·la associada"),
    modulePlotInfoPopover: String("Parcel·la en la qual es munta l'estació"),
    moduleEnable: String("Estat de l'estació"),
    moduleEnableInfoPopover: String("Estat de l'estació"),
    moduleInstallationDate: String("Data d'instal·lació"),
    moduleInstallationDateInfoPopover: String("Data en què es va dur a terme la instal·lació"),
    update: String("Actualitzar"),
    restoreModule: String("Retornar"),
    errorFieldRequired: String("Aquest camp és obligatori"),
    errorInvalidLength: String("La mida del camp ha de ser mínim de {length} caràcters"),
    errorNameAlreadyExists: String("Aquest nom ja existeix."),
    newModuleModalTitle: String("Formulari de la nova estació"),
    moduleActivationCode: String("Codi de l'estació o QR"),
    moduleActivationCodePlaceholder: String("Introduïu el codi de l'estació aquí"),
    moduleActivationCodeInfoPopover: String("El codi de l'estació es troba a l'etiqueta d'identificació de l'estació. Així mateix, si hi ha un codi QR en aquesta etiqueta, podeu escanejar-lo de manera que el codi s'introdueix automàticament."),
    moduleLatitudeLongitude: String("Ubicació de l'estació"),
    currentLocationButton: String("Ubicació actual"),
    moduleLatitudeLongitudeInfoPopover: String("Ubicació de l'estació en graus amb el format següent"),
    moduleLatitudePlaceholder: String("Latitud"),
    moduleLongitudePlaceholder: String("Longitud"),
    createButton: String("Afegir estació"),
    errorActivationCodeRegex: String("El format del codi introduït no és vàlid."),
    moduleLocationHeader: String("Ubicació"),
    modulePlotDefault: String("Seleccioneu una parcel·la..."),
    moduleErrorActivationCodeNotAllowed: String("Aquest codi d'activació ja s'ha utilitzat."),
    moduleErrorNotFound: String("Aquest codi d'activació no pertany a cap estació."),
    moduleErrorPlotNotSelected: String("No s'ha seleccionat cap parcel·la."),
    moduleCurrentStatus: String("Detalls"),
    moduleStatusButton: String("Veure"),
    moduleStatusModalTitle: String("Detalls de l'estació"),
    moduleStatusModuleName: String("Estació"),
    moduleStatusStatus: String("Estat real"),
    moduleStatusGood: String("Funcionament adequat"),
    moduleStatusWarning: String("Funciona amb errors"),
    moduleStatusError: String("No respon"),
    moduleStatusUpdateButton: String("Actualitzar"),
    moduleStatusLastMeasureDate: String("Data de l'últim enviament rebut"),
    moduleStatusMeasureNameHeader: String("Sensor"),
    moduleStatusProcessedHeader: String("Dades processades"),
    moduleStatusRawHeader: String("Dades en brut"),
    moduleStatus_battery_voltage: String("Tensió de la bateria"),
    moduleStatus_soil_1_meter: String("Sòl 1"),
    moduleStatus_soil_2_meter: String("Sòl 2"),
    moduleStatus_soil_3_meter: String("Sòl 3"),
    moduleStatus_leaf_meter: String("Humitat de les fulles"),
    moduleStatus_hum_meter: String("Humitat Relativa"),
    moduleStatus_temp_meter: String("Temperatura ambient"),
    moduleStatus_rain_meter: String("Pluviòmetre"),
    moduleStatus_gauge_meter: String("Caudalimetre"),
    moduleStatusErrorHeader: String("Llista d'errors"),
    moduleStatusErrorCode: String("Codi"),
    moduleStatusErrorComponent: String("Component"),
    moduleStatusErrorTimes: String("Vegades"),
    moduleNotPlotAllocated: String("No assignat"),
};

export default modules;